<template>
  <!-- Preferences "Dashboard" → dark navy back-to-app button -->
  <a-menu-item
    class="sb-item sb-item--dashboard"
    v-if="menuInfo.key === 'gotoDashboard'"
    :key="'nav-' + menuInfo.key"
    v-bind="$props"
    v-on="$listeners"
    :disabled="menuInfo.disabled"
    @click="goToDashboard()"
  >
    <router-link v-if="menuInfo.url" :to="menuInfo.url" class="sb-link">
      <span class="sb-icons">
        <img class="sb-icon" src="/resources/images/new-ui/sidebar/pref-back.svg" alt="" />
        <img v-if="!collapsed" class="sb-icon" src="/resources/images/new-ui/sidebar/pref-dashboard.svg" alt="" />
      </span>
      <span class="sb-title">{{ menuInfo.title }}</span>
      <span v-if="menuInfo.count" class="sb-badge">{{ menuInfo.count }}</span>
    </router-link>
  </a-menu-item>

  <!-- Standard menu item -->
  <a-menu-item
    v-else
    :class="['sb-item', { 'sb-item--aya': menuInfo.key === 'aya' }]"
    :key="menuInfo.key"
    v-bind="$props"
    v-on="$listeners"
    :disabled="menuInfo.disabled"
  >
    <router-link v-if="menuInfo.url" :to="menuInfo.url" class="sb-link">
      <img
        v-if="menuInfo.iconSvg"
        class="sb-icon"
        :src="iconPath"
        :alt="menuInfo.title"
      />
      <i v-else-if="menuInfo.icon" :class="['sb-icon-font', menuInfo.icon]"></i>
      <span class="sb-title">{{ menuInfo.title }}</span>
      <span v-if="menuInfo.count" class="sb-badge">{{ menuInfo.count }}</span>
    </router-link>
    <span v-else class="sb-link">
      <img
        v-if="menuInfo.iconSvg"
        class="sb-icon"
        :src="iconPath"
        :alt="menuInfo.title"
      />
      <i v-else-if="menuInfo.icon" :class="['sb-icon-font', menuInfo.icon]"></i>
      <span class="sb-title">{{ menuInfo.title }}</span>
      <span v-if="menuInfo.count" class="sb-badge">{{ menuInfo.count }}</span>
    </span>
  </a-menu-item>
</template>

<script>
import { Menu } from 'ant-design-vue'

export default {
  name: 'SubMenu',
  props: {
    ...Menu.Item.props,
    menuInfo: Object,
    styles: Object,
    collapsed: Boolean,
  },
  computed: {
    iconPath() {
      return `/resources/images/new-ui/sidebar/${this.menuInfo.iconSvg}.svg`
    },
  },
  methods: {
    goToDashboard() {
      if (['gotoDashboard'].includes(this.menuInfo.key)) {
        this.$store.commit('CHANGE_MENU_TYPE', { menuType: 'main' })
      }
    },
  },
}
</script>
